import { create } from 'zustand';
import api from '../api/axios';

interface MaintenanceState {
  isMaintenanceMode: boolean;
  isLoading: boolean;
  checkMaintenance: () => Promise<void>;
}

export const useMaintenanceStore = create<MaintenanceState>((set) => ({
  isMaintenanceMode: false,
  isLoading: true,
  checkMaintenance: async () => {
    try {
      const res = await api.get('/api/settings/public');
      if (res.data.success) {
        set({
          isMaintenanceMode: res.data.data.maintenance_mode === 'true',
          isLoading: false,
        });
      } else {
        set({ isLoading: false });
      }
    } catch {
      set({ isLoading: false });
    }
  },
}));